import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbDropdownModule, NgbDatepickerModule, NgbDateParserFormatter, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { AdditionOfManpowerService } from '../../../Model/AdditionReductionOfManpower/addition-of-manpower.service';
import { ComboService } from '../../../Model/Combo/combo.service';
import { CommonService } from '../../../Model/Common/common.service';
import { UtilityService } from '../../../Model/utility/utility.service';
import { SessionService } from '../../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { SelectWorkOrderforReductionComponent } from '../../select-work-orderfor-reduction/select-work-orderfor-reduction.component';
import { SelectWorkOrderforReductionNewComponent } from '../../SelectWorkOrderforReductionNew/select-work-orderfor-reduction-new/select-work-orderfor-reduction-new.component';
import { elements } from 'chart.js';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { ViewofReductonConfirmationListComponent } from '../../viewof-reducton-confirmation-list/viewof-reducton-confirmation-list.component';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-reduction-of-manpower-new',
  standalone: true,
  imports: [FormsModule, CommonModule, LoaderComponent, NgbDropdownModule, NgSelectModule, NgbDatepickerModule, DataTablesModule],
  providers: [
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
  templateUrl: './reduction-of-manpower-new.component.html',
  styleUrl: './reduction-of-manpower-new.component.scss'
})
export class ReductionOfManpowerNewComponent {
  isDisabled: boolean = false;
  User: any = null;

  Branchs: any[] = [];
  Clients: any[] = [];
  Sites: any[] = [];
  RedManpowers: any[] = [];

  Card = {
    Reduction: 0,
  }

  Filter = {
    WorkOrderDate: null as any,
    WorkOrderNumber: null,
    EntryNo: null,
    AllocationType: "R",
    BranchID: null as any,
    ClientID: null as any,
    SiteID: null as any,
    AllocationTypes: 'Reduction',
    Filename: null as any,
    FileURL: null as any,
    ESS_ShiftWiseManpowerMasterId: 0,
    IsAutoReduction: false,
    FromPageType: null
  }

  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    private comboload: ComboService,
    private toast: ToastService,
    private dateFormate: CustomDateParserFormatter,
    private modalService: NgbModal,
    protected common: CommonService,
    private session: SessionService,
    private utility: UtilityService,
    private siteadditionreduction: AdditionOfManpowerService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    this.common.getPageRights();
    this.User = this.session.GetUserDetails();
    this.route.params.subscribe(params => this.Filter.ESS_ShiftWiseManpowerMasterId = parseInt(params['id']));
    this.route.params.subscribe(params => this.Filter.FromPageType = params['type']);
    if (this.Filter.ESS_ShiftWiseManpowerMasterId == 0 && this.Filter.FromPageType == 's') {
      this.route.params.subscribe(params => this.Filter.BranchID = parseInt(params['bid']));
      this.route.params.subscribe(params => this.Filter.ClientID = parseInt(params['cid']));
      this.route.params.subscribe(params => this.Filter.SiteID = parseInt(params['sid']));
    } else if (this.Filter.FromPageType == 'o' || this.Filter.FromPageType == 'p') {
      this.Filter.AllocationType = 'O';
      this.Filter.AllocationTypes = 'Opening';
    }
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    //this.ComboLoad('Branch');
    if (this.Filter.ESS_ShiftWiseManpowerMasterId == 0) {
      this.ComboLoad('Branch', false);
      if (this.Filter.FromPageType == 's') {
        this.ComboLoad('Client', false);
        this.ComboLoad('Site', false);
      }
    } else {
      this.getData("View");
      this.getData("S");
    }
  }

  ComboLoad(Combotype: String, IsClear = true) {
    this.isDisabled = true
    this.RedManpowers = [];
    if (Combotype == 'Branch' && IsClear) {
      this.Branchs = [];
      this.Clients = [];
      this.Sites = [];

      this.Filter.BranchID = null;
      this.Filter.ClientID = null;
      this.Filter.SiteID = null;
    } else if (Combotype == 'Client' && IsClear) {
      this.Clients = [];
      this.Sites = [];
      this.Filter.ClientID = null;
      this.Filter.SiteID = null;
    } else if (Combotype == 'Site' && IsClear) {
      this.Sites = [];
      this.Filter.SiteID = null;
    }

    this.comboload.ComboLoad({
      'Combotype': Combotype,
      'BranchId': (Combotype == 'Branch' || Combotype == 'Client' || Combotype == 'Site') ? this.Filter.BranchID : 0,
      'ClientId': (Combotype == 'Client' || Combotype == 'Site') ? this.Filter.ClientID : 0,
      'SiteId': (Combotype == 'Site') ? this.Filter.SiteID : 0,
      'DesignationId': 0,
      'EmpType': ''
    }).subscribe({
      next: (response) => {
        if (response.ComboLoad.length >= 0) {
          if (Combotype == 'Branch') {
            this.Branchs = response.ComboLoad;
          } else if (Combotype == 'Client') {
            this.Clients = response.ComboLoad;
          } else if (Combotype == 'Site') {
            this.Sites = response.ComboLoad;
          }
        }
        else {
          this.toast.show({ message: 'No Data is there in Load', type: toastTypeEnum.warning });
        }
      },
      complete: () => {
        this.isDisabled = false
      },
      error: (error) => {
        this.isDisabled = false
      },
    });
  }

  Validate(form: any) {
    if (form.valid) {
      this.openDetailWorkOrder();
    } else {
      form.submitted = true;
    }
  }

  onFileSelected(event: any) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.uploadToFTP(input.files[0]);
    }
  }

  uploadToFTP(file: File) {
    this.isDisabled = true;
    if (!file) {
      return;
    }
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.utility.Upload({ 'DomainName': this.User.Domain, 'folder': 'AdditonOfManpower', 'CompanyCode': this.User.CompanyCode, 'FileBase64': reader.result }).subscribe((response: any) => {
        if (response.FileName != "") {
          // this.toast.show({ message: 'File uploaded successfully', type: toastTypeEnum.success });
          this.Filter.Filename = response.FileName;
          this.Filter.FileURL = response.Url;
        } else {
          this.toast.show({ message: 'File not uploaded to FTP', type: toastTypeEnum.danger });
        }
        this.isDisabled = false;
      }, (error) => {
        console.error('FTP Upload Error:', error);
        this.isDisabled = false;
      });
    };
  }

  removeFile() {
    this.Filter.Filename = null;
    this.Filter.FileURL = null;
    const fileInput = document.getElementById('formFileSm') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }

  viewFile() {
    window.open(this.Filter.FileURL, '_blank');
  }

  openDetailWorkOrder() {
    if ((this.Filter.ESS_ShiftWiseManpowerMasterId == 0 && this.common.PageRight.IsAdd) || (this.Filter.ESS_ShiftWiseManpowerMasterId > 0 && this.common.PageRight.IsEdit)) {
      const modalRef = this.modalService.open(SelectWorkOrderforReductionNewComponent, { centered: true, backdrop: 'static', size: 'xl' });
      modalRef.componentInstance.SiteID = this.Filter.SiteID;
      modalRef.componentInstance.SiteName = this.Sites.filter(e => e.SiteMasterID == this.Filter.SiteID)[0].SiteName;
      modalRef.componentInstance.ESS_ShiftWiseManpowerMasterId = this.Filter.ESS_ShiftWiseManpowerMasterId;

      modalRef.result.then((result) => {
        if (result.length > 0) {
          var showSuccess = false;
          result.forEach((element: any) => {
            if (this.RedManpowers.findIndex(e => e.RefESS_ShiftWiseManpowerDetailsId == element.RefESS_ShiftWiseManpowerDetailsId && moment(e.FromDate).isSame(element.FromDate)) == -1) {
              if (!this.Filter.IsAutoReduction) {
                this.RedManpowers.push(element);
                this.CalculateTotol();
                showSuccess = true;
              }
            } else {
              this.toast.show({ message: `Entry already exists.`, type: toastTypeEnum.warning });
            }

            if (result[result.length - 1].RefESS_ShiftWiseManpowerDetailsId == element.RefESS_ShiftWiseManpowerDetailsId && showSuccess) {
              this.toast.show({ message: 'Reduction Added in the List!', type: toastTypeEnum.success });
            }
          });
        }
      }).catch((reason) => {
        console.log('Modal dismissed:', reason);
      });
    }
  }

  deleteRow(index: number): void {
    if ((this.RedManpowers[index].IsMonthLocked == 0 || this.RedManpowers[index].EntryNo == undefined) && !this.Filter.IsAutoReduction) {
      const modalRef = this.modalService.open(ConfirmationComponent, {
        size: 'md',
        backdrop: 'static',
        windowClass: 'confirmation-modal'
      });
      modalRef.componentInstance.Message = 'Are you Sure want to Delete?'

      modalRef.result.then((result: any) => {
        if (result) {
          this.RedManpowers.splice(index, 1);
          this.CalculateTotol();
        }
      }).catch(() => {

      });
    }
  }

  save() {
    if ((this.Filter.ESS_ShiftWiseManpowerMasterId == 0 && this.common.PageRight.IsAdd) || (this.Filter.ESS_ShiftWiseManpowerMasterId > 0 && this.common.PageRight.IsEdit)) {
      if (this.Filter.ESS_ShiftWiseManpowerMasterId == 0 || (this.Filter.ESS_ShiftWiseManpowerMasterId > 0 && !this.Filter.IsAutoReduction)) {
        if (this.Filter.WorkOrderNumber != null && this.Filter.WorkOrderNumber != '' && (this.Filter.WorkOrderDate == null || this.Filter.WorkOrderDate == '')) {
          this.toast.show({ message: 'Please select Work Order Date', type: toastTypeEnum.warning });
        } else if (this.Filter.BranchID == null || this.Filter.BranchID <= 0) {
          this.toast.show({ message: 'Please select Branch!', type: toastTypeEnum.warning });
        } else if (this.Filter.ClientID == null || this.Filter.ClientID <= 0) {
          this.toast.show({ message: 'Please select Client!', type: toastTypeEnum.warning });
        } else if (this.Filter.SiteID == null || this.Filter.SiteID <= 0) {
          this.toast.show({ message: 'Please select Site!', type: toastTypeEnum.warning });
        } else if (this.Filter.ESS_ShiftWiseManpowerMasterId == 0 && this.RedManpowers.length == 0) {
          this.toast.show({ message: 'Please enter atleast one manpower!', type: toastTypeEnum.warning });
        } else {
          const modalRef = this.modalService.open(ConfirmationComponent, {
            size: 'md',
            backdrop: 'static',
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = 'Are you Sure want to save?'
          modalRef.result.then((result: any) => {
            if (result) {
              this.CheckManpowerValidation('WO');
            }
          }).catch(() => { });
        }
      }
    }
  }

  CheckManpowerValidation(SelecType: string) {
    this.isDisabled = false;
    const manpower = this.RedManpowers.map(element => {
      return {
        DesignationId: element.DesignationId,
        DutyId: element.DutyId,
        ShiftId: element.ShiftId,
        FromDate: element.FromDate,
        ToDate: element.ToDate,
        NoOfPerson: element.NoOfPerson,
        RefESS_ShiftWiseManpowerDetailsId: element.RefESS_ShiftWiseManpowerDetailsId,
        Remarks: element.Remarks,
        ESS_ShiftWiseManpowerDetailsId: element.ESS_ShiftWiseManpowerDetailsId
      };
    });
    const validation = {
      SelectType: SelecType,
      ESS_ShiftWiseManpowerMasterId: this.Filter.ESS_ShiftWiseManpowerMasterId,
      ESS_ShiftWiseManpowerDetails: manpower,
      AllocationType: '',
      WoNo: this.Filter.WorkOrderNumber,
      SiteId: this.Filter.SiteID,
    };

    this.siteadditionreduction.ESS_SiteManpowerValidation(validation).subscribe({
      next: (response) => {
        if (response.Table[0].Column1 === '01') {
          this.Insertupdate();
        } else {
          const modalRef = this.modalService.open(ViewofReductonConfirmationListComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Table1[0].Column1;
          modalRef.result.then((result: any) => {
            if (result) {
              this.Insertupdate();
            }
          }).catch(() => { });
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  Insertupdate() {
    this.isDisabled = true
    const manpower = this.RedManpowers.length > 0 ? this.RedManpowers.map(element => {
      return {
        ESS_ShiftWiseManpowerDetailsId: element.ESS_ShiftWiseManpowerDetailsId,
        DesignationId: element.DesignationId,
        DutyId: element.DutyId,
        ShiftId: element.ShiftId,
        FromDate: element.FromDate,
        ToDate: element.ToDate,
        NoOfPerson: element.NoOfPerson,
        RefESS_ShiftWiseManpowerDetailsId: element.RefESS_ShiftWiseManpowerDetailsId,
        Remarks: element.Remarks
      };
    }) : [];
    const additionData = {
      SelectType: this.Filter.ESS_ShiftWiseManpowerMasterId > 0 ? 'U' : 'I',
      ESS_ShiftWiseManpowerMasterId: this.Filter.ESS_ShiftWiseManpowerMasterId,
      ESS_ShiftWiseManpowerDetails: manpower,
      WoNo: this.Filter.WorkOrderNumber,
      WoDate: this.dateFormate.format(this.Filter.WorkOrderDate),
      SiteId: this.Filter.SiteID,
      UserID: this.User.UserId,
      AllocationType: 'R',
      Attachment: this.Filter.Filename
    };

    this.siteadditionreduction.ESS_SiteManpowerAdditionReduction(additionData).subscribe({
      next: (response) => {
        if (response.Error_Code == '365' || response.Error_Code == '368') {
          this.isDisabled = false;
          const modalRef = this.modalService.open(AlertSuccessComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
          modalRef.result.then((result: any) => {
            if (result) {
              this.Back();
            }
          });
        }
        else {
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
          modalRef.result.then((result: any) => { });
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  getData(Type: String) {
    this.isDisabled = true;
    const data = {
      SelectType: Type,
      ESS_ShiftWiseManpowerMasterId: this.Filter.ESS_ShiftWiseManpowerMasterId,
      AllocationType: this.Filter.AllocationType,
      WoNo: this.Filter.WorkOrderNumber,
      SiteId: this.Filter.SiteID,
      AsOnDate: null
    }

    this.siteadditionreduction.ESS_SiteManpowerAdditionReductionGet(data).subscribe({
      next: (response) => {
        if (Type == 'View') {
          if (response.Table.length > 0) {
            this.Filter.WorkOrderDate = (response.Table[0].WODate != null || response.Table[0].WODate != '') ? this.dateFormate.parse(response.Table[0].WODate) : null;
            this.Filter.WorkOrderNumber = response.Table[0].WONo;
            this.Filter.EntryNo = response.Table[0].EntryNo;
            this.Filter.BranchID = response.Table[0].BranchId;
            this.Filter.ClientID = response.Table[0].ClientId;
            this.Filter.SiteID = response.Table[0].SiteId;
            this.Filter.IsAutoReduction = response.Table[0].IsAutoReduction ?? false;
            this.Branchs = [{ BranchMasterID: response.Table[0].BranchId, BranchName: response.Table[0].BranchName }];
            this.Clients = [({ ClientGroupMasterID: response.Table[0].ClientId, ClientGroupName: response.Table[0].ClientGroupName })];
            this.Sites = [({ SiteMasterID: response.Table[0].SiteId, SiteName: response.Table[0].SiteName })];
          }
        } else if (Type == "S") {
          if (response.Table.length > 0) {
            this.RedManpowers = response.Table;
            this.CalculateTotol();
          }
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  SplitName() {
    return this.Filter.Filename.split("/")[1];
  }

  Back() {
    if (this.Filter.FromPageType == 'v') {
      this.router.navigate(['master/ViewAllocateManpowerNew']);
    }
    else {
      this.router.navigate(['master/sitewisemanpowersummarynew']);
    }
  }

  CalculateTotol() {
    this.Card.Reduction = this.RedManpowers.map(e => e.NoOfPerson).reduce((acc, cur) => acc + Number(cur), 0);
  }
}
